module.exports = __webpack_public_path__ + "91010c8622b1d1db633b91a438db34ab.svg";